import HeadToHeadCard from "../components/HeadToHeadCard";
import type { AppDataState } from "../api/useAppData";
import { getLocalDateKey } from "../lib/dates";
import { isKickedOffAwaitingData } from "../lib/fixtures";

export default function HeadToHeadsPage({ state }: { state: AppDataState }) {
  const { data } = state;
  if (!data) return <p>Loading…</p>;

  const todayKey = getLocalDateKey(new Date().toISOString());
  const today = data.allFixtures.filter(
    (f) =>
      getLocalDateKey(f.dateUtc) === todayKey &&
      !f.isPlaceholder &&
      f.homeOwner &&
      f.awayOwner
  );

  const kickedOff = data.allFixtures.filter((f) => isKickedOffAwaitingData(f));
  const live = [...data.liveFixtures, ...kickedOff];
  const upcoming = data.upcomingHeadToHeads.filter(
    (f) => !isKickedOffAwaitingData(f)
  );

  return (
    <>
      <h1>Head-to-heads</h1>

      <section className="section">
        <h2>Live</h2>
        {live.length === 0 ? (
          <div className="card empty-card">No live matches.</div>
        ) : (
          <div className="h2h-grid" aria-live="polite">
            {live.map((f) => (
              <HeadToHeadCard key={f.id} fixture={f} />
            ))}
          </div>
        )}
      </section>

      <section className="section">
        <h2>Today</h2>
        {today.length === 0 ? (
          <div className="card empty-card">No matches today.</div>
        ) : (
          <div className="h2h-grid">
            {today.map((f) => (
              <HeadToHeadCard key={f.id} fixture={f} />
            ))}
          </div>
        )}
      </section>

      <section className="section">
        <h2>Upcoming</h2>
        {upcoming.length === 0 ? (
          <div className="card empty-card">No upcoming head-to-heads.</div>
        ) : (
          <div className="h2h-grid">
            {upcoming.map((f) => (
              <HeadToHeadCard key={f.id} fixture={f} />
            ))}
          </div>
        )}
      </section>

      <section className="section">
        <h2>Recent</h2>
        {data.recentResults.length === 0 ? (
          <div className="card empty-card">No recent results.</div>
        ) : (
          <div className="h2h-grid">
            {data.recentResults.map((f) => (
              <HeadToHeadCard key={f.id} fixture={f} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}
